import apiHandler from "@/api/apps/apiHandler"
import apiUtils from "@/api/apiUtils"
import {$axios, $session} from "dot-framework";

const key = "/drive-app"
const version = "/v1"

export default {
    getDtmsGroup: async function (params) {
        const path = "/dtms/group/path"
        const data = apiUtils.removeNullValues(params)
        const url = apiUtils.makeUrl(key, version, path, data)
        const res = await apiHandler.$get(url)
        
        return apiUtils.getResponseData(res)
    },
    uploadImage: async function (form) {
        const path = "/doc/image"
        const url = apiUtils.makeUrl(key, version, path)
        const res = await apiHandler.$post(url, form)
        
        return apiUtils.getResponseData(res)
    },
    getDtmImageToDtms: async function (dtmNo, deviceKind) {
        const path = `/dtm/images/${dtmNo}/device/${deviceKind}/to-dtms`
        const url = apiUtils.makeUrl(key, version, path)
        const res = await apiHandler.$get(url)
        
        return apiUtils.getResponseData(res)
    },
    deleteCanvasDTMS: async function (dtmsFileNo, userNo) {
        const path = `/dtm/images/${dtmsFileNo}`
        const params = {
            "USER_NO": userNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)
        
        return apiHandler.$delete(url)
    },
    createDtmGroup: async function (params) {
        const path = "/dtm/groups"
        const url = apiUtils.makeUrl(key, version, path)
        const res = await apiHandler.$post(url, params, null, true)
        
        return apiUtils.getResponseData(res)
    },
    createDtmsImages: async function (formData) {
        const path = "/dtms/images"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, true)
    },
    changeDtmsStatus: async function (type, fileKey, params) {
        const path = `/dtm/${type}/${fileKey}/status`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$patch(url, params, true)
    },
    openDtmsImage: async function (fileKey, params) {
        const path = `/dtms/images/${fileKey}/open`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, true)
    },
    closeDtmsImage: async function (fileKey) {
        const path = `/dtms/images/${fileKey}/open`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$delete(url, null, true)
    },
    renameFolder: async function (fileKey, params) {
        const path = `/dtm/groups/${fileKey}`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$put(url, params, true)
    },
    renameFile: async function (fileKey, params) {
        const path = `/dtms/images/${fileKey}`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$put(url, params, true)
    },
    copyFolder: async function (fileKey, params) {
        const path = `/dtms/groups/${fileKey}/copy`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, true)
    },
    copyFile: async function (fileKey, params) {
        const path = `/dtms/images/${fileKey}/copy`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, true)
    },
    getDtmsGroupList: async function (params) {
        const path = "/dtms/groups"
        const query = apiUtils.removeNullValues(params)
        const url = apiUtils.makeUrl(key, version, path, query)
        
        return await apiHandler.$get(url, null, true)
    },
    saveAsTextbook: async function (formData) {
        const path = `/doc/html/from-string`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData)
    },
    updateHtmlDocs: async function (params) {
        const path = `/doc/html`
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$put(url, params)
    },
    uploadPdfToText: async function (formData) {
        const path = "/image/pdfToText"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, true)
    },
    getBrl: async function (dtmNo) {
        const path = "/doc/brl"
        const params = {
            "DTM_NO": dtmNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)
        
        return apiHandler.$get(url, null, false)
    },
    uploadDTMA: async function (formData) {
        const path = "/dtma/images/upload-to-json"
        const url = apiUtils.makeUrl(key, version, path)

        return apiHandler.$post(url, formData)
    },
    uploadDTMS: async function (formData) {
        const path = "/dtms/images/upload-to-json"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, null, true)
    },
    getFileDTMAImages: async function (fileno, canvasType) {
        const path = "/dtma/images/" + fileno + "/device/" + canvasType + "/to-dtms"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$get(url, null, true)
        
    },
    getFileDTMSImages: async function (fileno, canvasType) {
        const path = "/dtm/images/" + fileno + "/device/" + canvasType + "/to-dtms"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$get(url, null, true)
    },
    getAudioSync: async function (dtmNo) {
        const path = "/dtma/audio/sync"
        const params = {
            "DTM_NO": dtmNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)
        
        return apiHandler.$get(url)
    },
    getDTMSImage: async function (params) {
        const path = "/dtm/images"
        const query = apiUtils.removeNullValues(params)
        const url = apiUtils.makeUrl(key, version, path, query)
        
        return apiHandler.$get(url, null, true)
    },
    getDaisyContent: async function (dtmNo) {
        const path = "/doc/daisy-contents"
        const params = {
            "DTM_NO": dtmNo
        }
        const url = apiUtils.makeUrl(key, version, path, params)
        
        return apiHandler.$get(url)
    },
    addDtms: async function (params) {
        const path = "/dtm/images/from-dtms"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, params, null, true)
    },
    updateDtms: async function (fileNo, params) {
        const path = "/dtm/images/" + fileNo + "/from-dtms"
        const url = apiUtils.makeUrl(key, version, path)

        return apiHandler.$post(url, params, null, true)
    },
    saveAudio: async function (formData) {
        const path = "/dtma/audio"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$post(url, formData, true)
    },
    removeAudio: async function (formData) {
        const path = "/dtma/audio"
        const url = apiUtils.makeUrl(key, version, path)
        
        return apiHandler.$delete(url, formData, true)
    },
    getRemainingDrive: async function (params) {
        const path = "/doc/remaining"
        const url = apiUtils.makeUrl(key, version, path, params)
        const res = await apiHandler.$get(url)
        
        return apiUtils.getResponseData(res)
    }
}